/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-09 14:52:39
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import { getQueryString, decrypt, http } from '@shared';
import {
  TOKEN,
  REFRESH_TOKEN,
  LOCALE,
  APP_VERSION,
  HOUSE_ID,
  initI18n,
  SENSOR_LOGIN_ID,
} from '@constant';

const tokenInit = () => {
  let _token = localStorage.getItem(TOKEN) || '';
  const queryToken = getQueryString('token');
  if (queryToken) {
    _token = decrypt(queryToken) || _token;
    localStorage.setItem(TOKEN, _token);
  }

  let _refreshToken = localStorage.getItem(REFRESH_TOKEN) || '';
  const queryRefreshToken = getQueryString('refreshToken');
  if (queryRefreshToken) {
    _refreshToken = decrypt(queryRefreshToken) || _refreshToken;
    localStorage.setItem(REFRESH_TOKEN, _refreshToken);
  }

  let _locale = localStorage.getItem(LOCALE) || 'en-US';
  const queryLocale = getQueryString('language');
  if (queryLocale && initI18n.includes(queryLocale)) {
    _locale = queryLocale;
    localStorage.setItem(LOCALE, _locale);
  }

  // 用户 id 在神策的时候需要用到
  // 需要神策的时候再去上报登录事件
  const querySensor = getQueryString('sensor');
  if (querySensor) {
    const queryUserId = getQueryString('userId') || '';
    localStorage.setItem(SENSOR_LOGIN_ID, queryUserId);
  }

  let _appVersion = localStorage.getItem(APP_VERSION) || '';
  const queryAppVersion = getQueryString('appVersion');
  if (queryAppVersion) {
    _appVersion = queryAppVersion;
    localStorage.setItem(APP_VERSION, _appVersion);
  }

  let _houseId = localStorage.getItem(HOUSE_ID) || '';
  const queryHouseId = getQueryString('houseId');
  if (queryHouseId) {
    _houseId = queryHouseId;
    localStorage.setItem(HOUSE_ID, _houseId);
  }

  if (_token) {
    http.setOptions({
      headers: {
        token: _token,
      },
    });
  }
  if (_locale) {
    http.setOptions({
      headers: {
        locale: _locale,
      },
    });
  }
  if (_refreshToken) {
    http.setParameters({
      refreshToken: _refreshToken,
      expiresIn: 300,
      expiresTimestamp: Date.now() + 300 * 1000,
    });
  }
  return _token;
};

export default tokenInit;
